import starter from './app';
import './i18n';
import './lazyload-init';
import Generic from '~/pages/Generic';
import Profilo from './pages/areariservata/Profilo';
import Home from '~/pages/Home';
import Register from '~/pages/areariservata/Register';
import ConfirmEmail from '~/pages/areariservata/ConfirmEmail';
import CambioPassword from '~/pages/CambioPassword';
import RecuperaPassword from '~/pages/RecuperaPassword';
import ReimpostaPassword from '~/pages/ReimpostaPassword';
import SchedaVendita from '~/pages/SchedaVendita';
import Impersona from './pages/areariservata/Impersona';
import Acquista from './pages/Acquista';
import Accessibilita from './pages/Accessibilita';
import VendiCorporate from './pages/VendiCorporate';
import VendiPrivato from './pages/VendiPrivato';
import VendiMobili from './pages/VendiMobili';
import VendiAgenzia from './pages/VendiAgenzia';
import Contatti from './pages/Contatti';
import News from './pages/News';
import SearchResults from './pages/SearchResults';

let _ = starter({
    home: Home,
    index: Home,
    register: Register,
    profilo: Profilo,
    areariservata: Generic,
    confirmemail: ConfirmEmail,
    cambiopassword: CambioPassword,
    recuperapassword: RecuperaPassword,
    reimpostapassword: ReimpostaPassword,
    schedavendita: SchedaVendita,
    impersona: Impersona,
    acquista: Acquista,
    accessibilita: Accessibilita,
    contatti: Contatti,
    vendicorporate: VendiCorporate,
    vendiprivato: VendiPrivato,
    vendimobili: VendiMobili, 
    vendiagenzia: VendiAgenzia,
    news: News,
    searchresults: SearchResults
    
});


